/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICartLineCommentViewProps } from './cart-line-comment';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: ICartLineCommentViewProps) => {
    const { staticDisplay, cartLineCommentModuleProps, modal } = props;
    return (
        <Module {...cartLineCommentModuleProps}>
            {modal}
            <Node {...staticDisplay} />
        </Module>
    );
};
